
<template>
   <v-layout row wrap>
      <v-flex xs12>
         <v-card>
            <v-toolbar color="red darken-2" dark>
               <v-toolbar-title>{{ user.fullname }} {{ $v.dirty ? '*' : '' }}</v-toolbar-title>
            </v-toolbar>

            <v-form>
               <v-container grid-list-md>
                  <v-layout wrap>

                     <v-flex xs12 sm6>
                        <v-text-field
                           label="Identifiant"
                           v-model="user.username"
                           :disabled="userId > 0"
                           :error-messages="usernameErrors"
                           @input="$v.user.username.$touch(); $v.user.$touch()"
                           blur="$v.user.username.$touch(); $v.user.$touch()"
                        ></v-text-field>
                     </v-flex>
                     <v-flex xs12 sm6>
                        <v-text-field
                           label="E-mail"
                           name='email'
                           v-model="user.email"
                           :error-messages="emailErrors"
                           @input="$v.user.email.$touch(); $v.user.$touch()"
                           blur="$v.user.email.$touch(); $v.user.$touch()"
                        ></v-text-field>
                     </v-flex>

                     <v-flex xs12 sm12>
                        <v-autocomplete
                           label="Rôles"
                           :loading="loading"
                           :disabled="loggedInUserRoles.hasOwnProperty('salutance-user') || loggedInUserRoles.hasOwnProperty('diamond-user')"
                           multiple
                           chips
                           cache-items
                           :items="roles"
                           item-text="params.member_name"
                           item-value="id"
                           :search-input.sync="search"
                           v-model="user.roles"
                           @input="$v.user.roles.$touch(); $v.user.$touch()"
                           blur="$v.user.roles.$touch(); $v.user.$touch()"
                           :error-messages="rolesErrors"
                        ></v-autocomplete>
                     </v-flex>
                     
                     <v-flex xs10 v-if="userExtras.fullname && !userExtras.firstlastname">
                        <v-text-field
                           label="Nom complet"
                           v-model="user.extra.fullname"
                           @input="$v.user.$touch()"
                           blur="$v.user.$touch()"
                        ></v-text-field>
                     </v-flex>
                     
                     <v-flex xs12 sm5 v-if="userExtras.firstlastname">
                        <v-text-field
                           label="Prénom"
                           v-model="user.first_name"
                           @input="$v.user.$touch()"
                           blur="$v.user.$touch()"
                        ></v-text-field>
                     </v-flex>
                     <v-flex xs12 sm5 v-if="userExtras.firstlastname">
                        <v-text-field
                           label="Nom"
                           v-model="user.last_name"
                           @input="$v.user.$touch()"
                           blur="$v.user.$touch()"
                        ></v-text-field>
                     </v-flex>

                     <v-flex xs12 sm2>
                        <v-text-field
                           label="Tag"
                           v-model="user.extra.tag"
                           @input="$v.user.$touch()"
                           blur="$v.user.$touch()"
                        ></v-text-field>
                     </v-flex>

                     <v-flex xs12 v-if="userExtras.coaches">
                        <v-autocomplete
                           label="Tuteurs"
                           :loading="loading"
                           :disabled="loggedInUserRoles.hasOwnProperty('salutance-user')"
                           multiple
                           chips
                           cache-items
                           :items="users"
                           item-text="fullname"
                           item-value="id"
                           :search-input.sync="search"
                           v-model="user.coaches"
                           @input="$v.user.$touch(); $v.user.$touch()"
                           blur="$v.user.$touch(); $v.user.$touch()"
                        ></v-autocomplete>
                     </v-flex>
                    
                     <v-flex xs12 sm4 v-if="userExtras.nutrieduc">
                        <v-select
                           label="Sexe"
                           v-model="user.extra.gender"
                           :items="genders"
                           item-text="name"
                           item-value="code"
                           @input="$v.user.$touch()"
                           blur="$v.user.$touch()"
                           :error-messages="genderErrors"
                        ></v-select>
                     </v-flex>
                     <v-flex xs12 sm4 v-if="userExtras.nutrieduc">
                        <v-menu
                           ref="menu"
                           lazy
                           :close-on-content-click="false"
                           v-model="birthdate_menu"
                           :error-messages="birthdateErrors"
                           transition="scale-transition"
                           offset-y
                           full-width
                           :nudge-right="40"
                           min-width="290px"
                        >
                           <v-text-field
                              slot="activator"
                              label="Date de naissance"
                              :value="user.extra.birthdate ? moment(user.extra.birthdate).format('LL') : ''"
                              readonly
                           ></v-text-field>
                           <v-date-picker
                              ref="picker"
                              v-model="birthdate_temp"
                              :max="new Date().toISOString().substr(0, 10)"
                              locale="fr-FR"
                              :first-day-of-week="1"
                              scrollable
                              @input="$v.user.$touch()"
                              blur="$v.user.$touch()"
                           >
                              <v-spacer></v-spacer>
                              <v-btn flat color="primary" @click="birthdate_menu = false">Annuler</v-btn>
                              <v-btn flat color="primary" @click="user.extra.birthdate = birthdate_temp; birthdate_menu = false">OK</v-btn>
                           </v-date-picker>
                        </v-menu>
                     </v-flex>
                     <v-flex xs12 sm4 v-if="userExtras.nutrieduc">
                        <v-select
                           label="Fumeur"
                           v-model="user.extra.smoker"
                           :items="smokers"
                           item-text="name"
                           item-value="code"
                           @input="$v.user.$touch()"
                           blur="$v.user.$touch()"
                           :error-messages="smokerErrors"
                        ></v-select>
                     </v-flex>

                     <v-flex xs12 sm4 v-if="userExtras.heightweightbmi">
                        <v-text-field
                           label="Taille (cm)"
                           v-model="user.extra.height"
                           @input="$v.user.$touch()"
                           blur="$v.user.$touch()"
                           :error-messages="heightErrors"
                        ></v-text-field>
                     </v-flex>

                     <v-flex xs12 sm4 v-if="userExtras.heightweightbmi">
                        <v-text-field
                           label="Poids (kg)"
                           v-model="user.extra.weight"
                           @input="$v.user.$touch()"
                           blur="$v.user.$touch()"
                           :error-messages="weightErrors"
                        ></v-text-field>
                     </v-flex>

                     <v-flex xs12 sm4 v-if="userExtras.heightweightbmi">
                        <v-text-field
                           label="IMC"
                           :value="imc"
                           disabled
                        ></v-text-field>
                     </v-flex>
                  
                     <v-flex xs12 v-if="userExtras.fitbit">
                        <v-btn :href="fitbitAuthorizationURL" target="_blank">{{user.extra.fitbit_user_id ? "Réassocier" : "Associer"}} à un compte Fitbit</v-btn>
                     </v-flex>

                     <v-flex xs12>
                        <v-btn @click="saveOrUpdate" :disabled="!formValidAndDirty" flat style="width: 100%;">{{ saveMessage }}</v-btn>
                        <v-btn @click="sendResetPasswordMail" flat v-if="!creation" style="width: 100%;">Réinitialiser le mot de passe</v-btn>
                     </v-flex>
                  </v-layout>
               </v-container>
            </v-form>
         </v-card>
      </v-flex>

   </v-layout>
</template>

<script>
   import _ from 'lodash'
   import moment from 'moment'
   import { required, minLength, maxLength, email, decimal, between } from 'vuelidate/lib/validators'
   import config from '@/config'
   const axios = require("axios")

   export default {
           
      props: {
         userId: Number,
      },

      mounted: async function() {
         // fetch user list
         this.$store.dispatch('GET_USERS')
         this.updateUserView()
      },

      beforeRouteUpdate (to, from, next) {
         this.confirmLeaving(to, from, next)
      },
      beforeRouteLeave (to, from, next) {
         this.confirmLeaving(to, from, next)
      },

      data () {
         return {
            user: {
               password: config.INITIAL_PASSWORD, // must be non-empty
               date_joined: "1970-01-01T00:00", // must be non-null
               roles: [], // must be non-null
               extra: {},
            },
            genders: [
               { code: 'M', name: "Masculin" },
               { code: 'F', name: "Féminin" },
            ],
            smokers: [
               { code: 'Y', name: "Fumeur" },
               { code: 'N', name: "Non-fumeur" },
            ],
            birthdate_menu: false,
            birthdate_temp: null,
            superuser: false,
            loading: false,
            search: null,
            select: [],
            moment: moment,
            fitbitAuthorizationURL: null,
         }
      },

      // vuelidate validators (as a function)
      validations() {
         let validators = {
            user: {
               username: {
                  required,
                  minLength: minLength(4),
                  maxLength: maxLength(150),
                  validChars(value) {
                     let pattern = /^[a-zA-Z\u00C0-\u024F0-9_@+.-]+$/i
                     return pattern.test(value)
                  },
                  isUnique(value) {
                     if (!this.creation) return true
                     return this.$store.dispatch('IS_USERNAME_AVAILABLE', value)
                  },
               },
               email: {
                  required,
                  email,
               },
               roles: {
                  required,
               },
            }
         }
         if (this.userExtras.heightweightbmi) {
            if (validators.user.extra === undefined) validators.user.extra = {}
            Object.assign(validators.user.extra, {
               height: {
                  required,
                  decimal,
                  between: between(100, 250)
               },
            })
            Object.assign(validators.user.extra, {
               weight: {
                  required,
                  decimal,
                  between: between(30, 300)
               },
            })
         }
         if (this.userExtras.nutrieduc) {
            if (validators.user.extra === undefined) validators.user.extra = {}
            Object.assign(validators.user.extra, {
               gender: {
                  required,
               },
            })
            Object.assign(validators.user.extra, {
               birthdate: {
                  required,
               },
            })
            Object.assign(validators.user.extra, {
               smoker: {
                  required,
               },
            })
         }
         return validators
      },

      computed: {
         users () {
            return Object.entries(this.$store.state.users).map(function([key, value]) {
               return value
            })
         },
         usernameErrors () {
            const errors = []
            if (!this.$v.user.username.$dirty) return errors
            !this.$v.user.username.required && errors.push("L'identifiant est obligatoire")
            !this.$v.user.username.minLength && errors.push("L'identifiant doit faire au moins 4 caractères")
            !this.$v.user.username.minLength && errors.push("L'identifiant doit faire moins de 150 caractères")
            !this.$v.user.username.isUnique && errors.push("L'identifiant est déjà utilisé")
            !this.$v.user.username.validChars && errors.push("L'identifiant ne doit contenir que des lettres, chiffres ou _, @, +, ., -")
            return errors
         },
         emailErrors () {
            const errors = []
            if (!this.$v.user.email.$dirty) return errors
            !this.$v.user.email.required && errors.push("L'e-mail est obligatoire")
            !this.$v.user.email.email && errors.push("L'e-mail est incorrect")
            return errors
         },
         rolesErrors () {
            const errors = []
            if (!this.$v.user.roles.$dirty) return errors
            !this.$v.user.roles.required && errors.push("Un rôle au moins est obligatoire")
            return errors
         },
         heightErrors () {
            const errors = []
            if (!this.$v.user.extra.height.$dirty) return errors
            !this.$v.user.extra.height.required && errors.push("La taille est obligatoire")
            !this.$v.user.extra.height.decimal && errors.push("La taille doit être un nombre en cm (ex: 175)")
            !this.$v.user.extra.height.between && errors.push("La taille (en cm) doit être un nombre compris entre 100 et 250")
            return errors
         },
         weightErrors () {
            const errors = []
            if (!this.$v.user.extra.weight.$dirty) return errors
            !this.$v.user.extra.weight.required && errors.push("Le poids est obligatoire")
            !this.$v.user.extra.weight.decimal && errors.push("Le poids doit être un nombre en kg (ex: 82.5)")
            !this.$v.user.extra.weight.between && errors.push("Le poids (en kg) doit être compris entre 30 et 300")
            return errors
         },
         genderErrors () {
            const errors = []
            if (!this.$v.user.extra.gender.$dirty) return errors
            !this.$v.user.extra.gender.required && errors.push("Le genre est obligatoire")
            return errors
         },
         birthdateErrors () {
            const errors = []
            if (!this.$v.user.extra.birthdate.$dirty) return errors
            !this.$v.user.extra.birthdate.required && errors.push("La date de naissance est obligatoire")
            return errors
         },
         smokerErrors () {
            const errors = []
            if (!this.$v.user.extra.smoker.$dirty) return errors
            !this.$v.user.extra.smoker.required && errors.push("Le statut de fumeur est obligatoire")
            return errors
         },
         creation () {
            return this.userId === 0
         },
         loggedInUserRoles() {
            return this.$store.getters.loggedInUserRoles
         },
         roles () {
            return Object.entries(this.$store.state.roles).map(function([key, value]) {
               return value
            })
         },
         roleUIDs () {
            return Object.entries(this.$store.state.roles).map(function([key, value]) {
               return value.uid
            })
         },
         userExtras () {
            let tagDict = {}
            let self = this
            this.user.roles.forEach(function(roleId) {
               let role = self.$store.state.roles[roleId]
               if (role && role.params && role.params.user_extras) {
                  Object.assign(tagDict, role.params.user_extras)
               }
            })
            return tagDict
         },
         title () {
            return this.userId ? this.user.fullname : "Nouvel utilisateur"
         },
         formValid () {
            if (this.$v.user.username.$error) return false
            if (this.$v.user.email.$error) return false
            if (this.$v.user.roles.$error) return false
            if (this.userExtras.nutrieduc && this.$v.user.extra.gender.$error) return false
            if (this.userExtras.nutrieduc && this.$v.user.extra.birthdate.$error) return false
            if (this.userExtras.nutrieduc && this.$v.user.extra.smoker.$error) return false
            if (this.userExtras.heightweightbmi && this.$v.user.extra.height.$error) return false
            if (this.userExtras.heightweightbmi && this.$v.user.extra.weight.$error) return false
            return true
         },
         formDirty () {
            return this.$v.user.$dirty
         },
         formValidAndDirty () {
            return this.formValid && this.formDirty
         },
         saveMessage () {
            return this.userId === 0 ? "Enregistrer et envoyer mail d'initialisation" : "Enregistrer"
         },
         imc() {
            let bmi = this.user.extra.weight / (this.user.extra.height * this.user.extra.height / 10000.)
            if (isNaN(bmi)) {
               return ''
            } else {
               return bmi.toLocaleString('fr-FR', { maximumFractionDigits: 1 })
            }
         },
      },

      watch: {
         search (val) {
            val && this.querySelections(val)
         },
         userId (val) {
            this.updateUserView()
         },
      },

      methods: {
         setUser(userId) {
            this.$v.$reset()
            if (this.userId > 0) {
               // Vuex user
               let user = this.$store.state.users[this.userId]
               // form operates on a clone of Vuex user (otherwise, direct store change)
               this.user = _.clone(user)
            } else {
               this.user = {
                  username: null,
                  password: config.INITIAL_PASSWORD, // must be non-empty
                  date_joined: "1970-01-01T00:00", // must be non-null
                  roles: [], // must be non-null
                  extra: {},
               }
            }
            // used for selecting user in cousin user list
            this.$emit('userIdChanged', this.userId)
         },
         updateUserView: async function() {
            this.setUser(this.userId)
            if (this.userId > 0 && this.userExtras.fitbit) {
               this.fitbitAuthorizationURL = await this.getFitbitAuthorizationURL()
            }
         },
         isUserExtra (tag) {
            return this.userExtras.hasOwnProperty(tag)
         },

         saveOrUpdate () {
            this.$v.$reset()
            if (this.creation) {
               this.createUser(this.user)
            } else {
               this.updateUser(this.user)
            }
         },
         async createUser(userData) {
            try {
                this.$store.commit('WAITING', true)
               // create user
               let user = await this.$store.dispatch('POST_USER', userData)
               this.$store.commit('SNACKBAR', { timeout: 1500, text: "Utilisateur créé: " + user.username, color: 'green' })
               // replace create view by read/update view
               this.$router.push(`/user-manager/user/${user.id}`)
               // send account activation mail
               await this.$store.dispatch('SEND_ACTIVATE_ACCOUNT_MAIL', user.id)
               this.$store.commit('SNACKBAR', { timeout: 1500, text: "Mail d'activation de compte envoyé", color: 'green' })
            } catch(e) {
               if (e.message === '400') {
                  this.$store.commit('SNACKBAR', { timeout: 4000, text: `Erreur lors de la création, l'identifiant '${userData.username}' est probablement déjà utilisé`, color: 'red' })
               } else {
                  this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur inconnue lors de la création", color: 'red' })
               }
            } finally {
                this.$store.commit('WAITING', false)
            }
         },
         async updateUser(userData) {
            try {
               this.$store.commit('WAITING', true)
               await this.$store.dispatch('PUT_USER', userData)
               this.$store.commit('SNACKBAR', { timeout: 1500, text: "Modifications enregistrées", color: 'green' })
            } catch(err) {
               this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de l'enregistrement", color: 'red' })
            } finally {
               this.selectedUserDirty = false
               this.$store.commit('WAITING', false)
            }
         },

         sendResetPasswordMail() {
            this.$store.commit('WAITING', true)
            let authData = this.$store.state.authenticationData
            try {
               let promise = axios({
                  method: 'post',
                  url: config.RESET_PASSWORD_MAIL_URL,
                  headers: {"Authorization": `JWT ${authData.token}`},
                  data: {"user_id": this.userId},
               })
               this.$store.commit('SNACKBAR', { timeout: 1500, text: "Mail de réinitialisation de compte envoyé", color: 'green' })
               let self = this
               promise.catch(function(error) {
                  self.$store.commit('SNACKBAR', { timeout: 3500, text: `Erreur lors de l'envoi du mail de réinitialisation de compte de : '${self.user.fullname}'`, color: 'red' })
               })
            } catch(err) {
               this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de l'envoi du mail de réinitialisation de compte", color: 'red' })
            } finally {
               this.$store.commit('WAITING', false)
            }
         },

         async querySelections (text) {
         },

         async confirmLeaving(to, from, next) {
            if (this.formDirty) {
               // form is dirty: ask for confirmation to leave
               let { save, proceed } = await this.$store.dispatch('confirmer/ask', {
                  title: 'Quitter le formulaire sans sauvegarder ?',
                  body: 'Vous avez effectué des modifications dans le formulaire et vous vous apprêtez à en sortir sans sauvegarder',
                  choices: [
                     { text: "Sauvegarder et quitter", value: { save: true, proceed: true } },
                     { text: "Quitter sans sauvegarder", value: { save: false, proceed: true } },
                     { text: "Annuler", value: { save: false, proceed: false } },
                  ],
               })
               if (save) {
                  // save when choice is 'Sauvegarder et quitter'
                  this.saveOrUpdate()
               }
               // proceed (or not) with route change
               next(proceed)
            } else {
               // form is not dirty: proceed with route change
               next()
            }
         },

         async getFitbitAuthorizationURL() {
            let authorizationURL = null
            try {
               let response = await axios.get(config.FITBIT_CLIENT_ID_URL)
               let fitbitClientId = response.data
               let redirectUri = config.APIBASE.indexOf('nutrieduc') !== -1 ?
                  "https://nutrieduc.fr:443/api/fitbit-authorize" :
                  "https://shdl.fr:443/api/fitbit-authorize"
               authorizationURL =
                  "https://www.fitbit.com/oauth2/authorize" +
                  "?response_type=code" +
                  // force login with Fitbit user's credentials and ask for consent
                  "&prompt=login consent" +
                  // 'state' is the way to pass additionnal information - in this case the user id to whom refresh token is created
                  "&state=" + this.userId +
                  "&client_id=" + fitbitClientId +
                  "&redirect_uri=" + encodeURIComponent(redirectUri) +
                  "&scope=activity%20heartrate%20location%20nutrition%20profile%20settings%20sleep%20social%20weight" +
                  "&expires_in=604800"
               //console.log('authorizationURL', authorizationURL)
            } catch(error) {
               console.error(error)
            }
            return authorizationURL
         },

      },
   }
</script>



// WEBPACK FOOTER //
// User.vue?0f776f0d